import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";
import { useCurrencies } from "@/modules/reports/contexts/currency-context";

export const useCollectedBilling = (jobType, filters = {}) => {
  const { convertToINR } = useCurrencies();

  return useQuery({
    queryKey: ["collected-billing", jobType, filters],
    queryFn: async () => {
      const billingFilter = {
        type: { _eq: jobType },
        job: {
          ...(filters?.jobs?.employees?.employee?.department?._in
            ? {
                employees: {
                  employee: {
                    department: {
                      _in: filters.jobs.employees.employee.department._in,
                    },
                  },
                },
              }
            : {}),
        },
        status: { _eq: "collected" },
        collected_date: {
          ...(filters?.jobs?.billables?.collected_date
            ? {
                _gte: filters.jobs.billables.collected_date._gte,
                _lte: filters.jobs.billables.collected_date._lte,
              }
            : {}),
        },
        ...(filters?.sales_coordinator
          ? {
              job: {
                project: {
                  sales_coordinator: { _eq: filters.sales_coordinator._eq },
                },
              },
            }
          : {}),
        ...(filters?.client
          ? { job: { project: { client: { _eq: filters.client._eq } } } }
          : {}),
      };

      const query = {
        fields: [
          "amount",
          "adjusted_amount",
          "currency",
          "collected_date",
          "status",
          "type",
        ],
        filter: billingFilter,
        limit: -1,
      };

      const response = await getItemsFromCollection("billables", query);

      const collectedBilling = response.reduce((total, billable) => {
        const amount = billable.adjusted_amount || 0;
        return total + convertToINR(amount, billable.currency);
      }, 0);

      return collectedBilling;
    },
    enabled: !!jobType,
  });
};
